/**
 * cus-references.js — Auto-detect and wrap "References:" sections
 * in product description (.custom-product-description) with academic
 * journal styling. No changes needed to product editing workflow.
 */
(function () {
  'use strict';

  var KEYWORD = /^references\s*:/i;
  var CONTAINER_SEL = '.custom-product-description';

  function findRefNode(container) {
    // Walk direct children to find the one starting with "References:"
    var children = container.childNodes;
    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      var text = (node.textContent || '').trim();
      if (KEYWORD.test(text)) return node;
    }
    return null;
  }

  function extractItems(nodes) {
    // Collect reference items from sibling nodes after the keyword node.
    // Sources: <ol>/<ul> list items, or <p>/text lines with numbering.
    var items = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var tag = node.nodeName && node.nodeName.toLowerCase();

      if (tag === 'ol' || tag === 'ul') {
        var lis = node.querySelectorAll('li');
        for (var j = 0; j < lis.length; j++) {
          items.push(lis[j].innerHTML.trim());
        }
      } else {
        // Could be <p> or text node with one or more references
        var html = node.innerHTML != null ? node.innerHTML.trim() : (node.textContent || '').trim();
        if (!html) continue;
        // Split by <br> tags
        var parts = html.split(/<br\s*\/?>/i);
        for (var k = 0; k < parts.length; k++) {
          // Strip leading numbering: "1." "2." "[1]" "(1)" etc.
          var clean = parts[k].replace(/^\s*[\[\(]?\d+[\]\)]?[.\s)\]]*/, '').trim();
          if (clean) items.push(clean);
        }
      }
    }
    return items;
  }

  function buildRefZone(items) {
    var zone = document.createElement('div');
    zone.className = 'cus-ref-zone';

    var title = document.createElement('div');
    title.className = 'cus-ref-zone__title';
    title.textContent = 'References';
    zone.appendChild(title);

    var ol = document.createElement('ol');
    ol.className = 'cus-ref-zone__list';
    for (var i = 0; i < items.length; i++) {
      var li = document.createElement('li');
      li.innerHTML = items[i];
      // Force all links to open in new tab
      var links = li.querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) {
        links[j].setAttribute('target', '_blank');
        links[j].setAttribute('rel', 'noopener noreferrer');
      }
      ol.appendChild(li);
    }
    zone.appendChild(ol);
    return zone;
  }

  function processContainer(container) {
    var refNode = findRefNode(container);
    if (!refNode) return;

    // Gather refNode + all siblings after it
    var toRemove = [];
    var afterNodes = [];
    var node = refNode.nextSibling;
    while (node) {
      afterNodes.push(node);
      toRemove.push(node);
      node = node.nextSibling;
    }
    toRemove.push(refNode);

    // Check if the keyword node itself contains the items (single-node case)
    var refText = (refNode.textContent || '').trim();
    var afterKeyword = refText.replace(KEYWORD, '').trim();

    var items;
    if (afterKeyword && afterNodes.length === 0) {
      // Everything is in one node — split by <br> or numbered lines
      var html = refNode.innerHTML || refText;
      var afterHtml = html.replace(/^[^:]*:\s*(<br\s*\/?>)?/i, '');
      var parts = afterHtml.split(/<br\s*\/?>/i);
      items = [];
      for (var i = 0; i < parts.length; i++) {
        var clean = parts[i].replace(/^\s*[\[\(]?\d+[\]\)]?[.\s)\]]*/, '').trim();
        if (clean) items.push(clean);
      }
    } else {
      items = extractItems(afterNodes);
    }

    if (items.length === 0) return;

    var zone = buildRefZone(items);

    // Insert zone where refNode was, remove originals
    refNode.parentNode.insertBefore(zone, refNode);
    for (var j = 0; j < toRemove.length; j++) {
      if (toRemove[j].parentNode) {
        toRemove[j].parentNode.removeChild(toRemove[j]);
      }
    }
  }

  function init() {
    var containers = document.querySelectorAll(CONTAINER_SEL);
    for (var i = 0; i < containers.length; i++) {
      processContainer(containers[i]);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: re-run on section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var containers = e.target.querySelectorAll(CONTAINER_SEL);
      for (var i = 0; i < containers.length; i++) {
        processContainer(containers[i]);
      }
    });
  }
})();
